import { useTheme } from 'styled-components';
import { Compiled, Mixin } from './createTheme.types';

export const useMixin = <T,>(mixin: Compiled<Mixin<T>> | Mixin<T>) => {
  const theme = useTheme();
  return mixin({ theme });
};
